import type { ISiteOption } from "@/customTypings/customer/Customer";
import { filterDefaultsEligibleSites, pickInitialDefaultsSiteId } from "./wasteMovementSiteSelection";

export function readSiteIdFromListFilters(persistanceKey: string): string | null {
    try {
        const raw = localStorage.getItem(`${persistanceKey}-filters`);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as Array<{ filter?: { member?: string }; value?: string | null }>;
        const siteFilter = parsed.find((f) => f.filter?.member === "siteId");
        const value = siteFilter?.value;
        return typeof value === "string" && value.length > 0 ? value : null;
    } catch {
        return null;
    }
}

export type ResolveWasteMovementDefaultsSiteIdOptions = {
    storedSiteId?: string | null;
};

/**
 * Resolves site context for Waste Movement Defaults pages.
 * Uses enabled, non-deleted sites only. Precedence: stored defaults site → sole site → first alphabetical.
 */
export function resolveWasteMovementDefaultsSiteId(
    availableSites: ISiteOption[],
    options: ResolveWasteMovementDefaultsSiteIdOptions = {}
): string | null {
    const eligible = filterDefaultsEligibleSites(availableSites);
    return pickInitialDefaultsSiteId(eligible, options.storedSiteId);
}
